import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Why Get a Flutter App For Your <span>Business?</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              With Flutter's market share set to double by 2024, now's the time
              to embrace this powerful tool for cross-platform mobile and web
              development. As your trusted Flutter web app development company,
              we bring your vision to life across platforms. With Flutter's
              rising popularity, now's the time to embrace this versatile tool
              for an impactful, user-friendly, and future-proof digital
              presence.
            </p>
            <p>
              Here are the Flutter app development benefits that can
              revolutionize your business operations:
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Cross-Platform Compatibility</h6>
                <p>
                  Flutter allows you to develop Android and iOS apps utilizing a
                  single codebase, saving time and cost.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Rich User Interfaces</h6>
                <p>
                  Flutter's easy-to-read UI components and customizable widgets
                  allow the development of visually striking and intuitive
                  interfaces, improving user experience.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Fast Development</h6>
                <p>
                  {" "}
                  Flutter's hot reload feature consents to real-time code
                  variations, speeding up development and allowing swift
                  iterations and updates.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Native Performance</h6>
                <p>
                  Flutter apps offer near-native performance as they are
                  compiled directly to native machine code, warranting smooth
                  and responsive user interactions.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Open-Source Community</h6>
                <p>
                  As Flutter is an open-source tool, it benefits from a dynamic
                  community, providing support, plugins, and resources to
                  developers, nurturing constant advancements and innovation.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Cost-Effectiveness</h6>
                <p>
                  Flutter can target several platforms, which is why businesses
                  can enjoy cost-effectiveness on development and maintenance,
                  making it an economical choice for development.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
